import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CustomMealPlan,
  recipes,
} from "src/funnels/custom-plans/meal-plans/meal-plans";

export interface CustomPlansState {
  customMealPlans: Array<CustomMealPlan>;
}

const DEFAULT_STATE: CustomPlansState = {
  customMealPlans: recipes,
};

const customPlansSlice = createSlice({
  name: "customPlansSlice",
  initialState: DEFAULT_STATE,
  reducers: {
    setCustomPlansSlice(state, action: PayloadAction<CustomPlansState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setCustomPlansSlice } = customPlansSlice.actions;

export default customPlansSlice.reducer;
